import React from 'react';
import { twMerge } from 'tailwind-merge';

import { postWebUiApi } from '../../api';
import { WebUiAlert } from '../../components/alert';
import WebUiPageWrapper from '../../components/page-wrapper';

type Bridge = {
  vlan_id: number;
  dhcp_client?: boolean;
  dhcp_provision?: boolean;
  dhcp_filter?: boolean;
  ip?: string;
  sm?: string;
  gw?: string;
};

export default function WebUiStatusDhcpClientPage() {
  const [rows, setRows] = React.useState<Bridge[]>([]);
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    const data = await postWebUiApi<Bridge[]>({
      service: 'vlan',
      access: 'get',
      command: 'get bridges',
    });
    setRows(data ?? []);
  }, []);

  React.useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        await reload();
        if (alive) setError(null);
      } catch (err) {
        if (alive) setError((err as Error).message);
      }
    };
    load().catch(() => {});
    const t = window.setInterval(() => load().catch(() => {}), 5000);
    return () => {
      alive = false;
      window.clearInterval(t);
    };
  }, [reload]);

  return (
    <WebUiPageWrapper titleList={['Status', 'DHCP Client']}>
      {error ? <WebUiAlert type="error" message={error} /> : null}
      <div className="webui-panel w-[calc(100%-20px)]">
        <h4 className="font-bold">DHCP Client Status</h4>
        <table className="webui-table w-full">
          <thead>
            <tr className="webui-table-row-head">
              <th rowSpan={2}>Interface</th>
              <th colSpan={3}>DHCP Client Configuration</th>
              <th colSpan={3}>Current Status</th>
              <th>Status</th>
            </tr>
            <tr className="webui-table-row-head">
              <th>Operation</th>
              <th>Provision</th>
              <th>Filter</th>
              <th>IP Address</th>
              <th>Netmask</th>
              <th>Gateway</th>
              <th>DHCP Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((i) => (
              <tr key={i.vlan_id} className="webui-table-row-content">
                <td>{i.vlan_id === 0 ? 'Lan' : `VLAN_ID${i.vlan_id}`}</td>
                <td className="text-center">
                  {i.dhcp_client ? 'Enabled' : 'Disabled'}
                </td>
                <td className="text-center">
                  {i.dhcp_provision ? 'Enabled' : 'Disabled'}
                </td>
                <td className="text-center">
                  {i.dhcp_filter ? 'Enabled' : 'Disabled'}
                </td>
                <td className="text-center">{i.ip ?? ''}</td>
                <td className="text-center">{i.sm ?? ''}</td>
                <td className="text-center">{i.gw ?? ''}</td>
                <td
                  className={twMerge(
                    'text-center',
                    i.dhcp_client ? 'text-green-500' : 'text-red-500',
                  )}
                >
                  {i.dhcp_client ? 'Active' : 'Inactive'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </WebUiPageWrapper>
  );
}
